/* eslint-disable comma-dangle */
/* eslint-disable quote-props */
/* eslint-disable quotes */
export default {
    "en": {
        "*^&$@%": "*^&$@%",
        "Aboveboard": "Aboveboard",
        "Achievements": "Achievements",
        "*Allows your data to be saved between devices": "*Allows your data to be saved between devices",
        "Already have an account?": "Already have an account?",
        "Avatar": "Avatar",
        "Bring it on": "Bring it on",
        "Change": "Change",
        "Chat": "Chat",
        "Close Game": "Close Game",
        "Continue": "Continue",
        "CrazyNinja": "CrazyNinja",
        "Create": "Create",
        "Create Account": "Create Account",
        "Create or join an existing room.": "Create or join an existing room.",
        "Create Room": "Create Room",
        "Delete": "Delete",
        "Delete All": "Delete All",
        "Don't have an account?": "Don't have an account?",
        "Easy": "Easy",
        "Emojis": "Emojis",
        "Email Login": "Email Login",
        "Enter": "Enter",
        "Finding server...": "Finding server...",
        "Forgot Password": "Forgot Password",
        "Gift in crib": "Gift in crib",
        "Good Game": "Good Game",
        "Good run": "Good run",
        "Got lucky": "Got lucky",
        "Had enough?": "Had enough?",
        "Hard": "Hard",
        "Hello": "Hello",
        "Hi": "Hi",
        "How about 2 out of 3?": "How about 2 out of 3?",
        "Impossible": "Impossible",
        "Its real": "Its real",
        "Leaderboard": "Leaderboard",
        "Level": "Level",
        "Login": "Login",
        "Login as Guest": "Login as Guest",
        "Login to facebook to use your facebook profile": "Login to facebook to use your facebook profile",
        "Login with Email": "Login with Email",
        "Login with Facebook": "Login with Facebook",
        "Maybe next time": "Maybe next time",
        "Medium": "Medium",
        "More Games": "More Games",
        "Name": "Name",
        "Nice Hand": "Nice Hand",
        "Nicely played": "Nicely played",
        "No": "No",
        "No lurch": "No lurch",
        "No Skunk": "No Skunk",
        "No thank you": "No thank you",
        "Nooooooooooo": "Nooooooooooo",
        "OK": "OK",
        "Online": "Online",
        "Oops": "Oops",
        "Ouch": "Ouch",
        "Phrases": "Phrases",
        "Play": "Play",
        "Play a Friend": "Play a Friend",
        "Play Again?": "Play Again?",
        "Private Room": "Private Room",
        "Profile": "Profile",
        "Random": "Random",
        "Rank": "Rank",
        "Rating": "Rating",
        "Rematch?": "Rematch?",
        "Restore Data": "Restore Data",
        "Select an avatar": "Select an avatar",
        "Sorry": "Sorry",
        "Statistics": "Statistics",
        "Thank You": "Thank You",
        "Thanks": "Thanks",
        "This will delete all of your data": "This will delete all of your data",
        "Well played": "Well played",
        "Yes": "Yes",
        "You're welcome": "You're welcome"
    },
    "fr": {
        "*^&$@%": "*^&$@%",
        "Aboveboard": "Honnête",
        "Achievements": "Succès",
        "*Allows your data to be saved between devices": "*Permet à vos données d'être enregistrées entre les appareils",
        "Already have an account?": "Already have an account?",
        "Avatar": "Avatar",
        "Bring it on": "Allez",
        "Change": "Changer",
        "Chat": "Bavarder",
        "Close Game": "Close Game",
        "Continue": "Continue",
        "CrazyNinja": "CrazyNinja",
        "Create": "Create",
        "Create Account": "Create Account",
        "Create or join an existing room.": "Créez ou rejoignez une salle existante.",
        "Create Room": "Créer une chambre",
        "Delete": "Effacer",
        "Delete All": "Supprimer tout",
        "Don't have an account?": "Don't have an account?",
        "Easy": "Facile",
        "Email Login": "Email Login",
        "Emojis": "Emojis",
        "Enter": "Entrer",
        "Finding server...": "Trouver un serveur...",
        "Forgot Password": "Forgot Password",
        "Gift in crib": "Cadeau dans le crible",
        "Good Game": "Bonne partie",
        "Good run": "Belle suite",
        "Got lucky": "J'ai eu de la chance",
        "Had enough?": "Tu en as assez?",
        "Hard": "Difficile",
        "Hello": "Allô",
        "Hi": "Bonjour",
        "How about 2 out of 3?": "Un 2 de 3?",
        "Impossible": "Impossible",
        "Its real": "C'est réel",
        "Language": "La langue",
        "Leaderboard": "Classement",
        "Level": "Niveaux",
        "Login": "Login",
        "Login as Guest": "Se connecter en tant qu'invité",
        "Login to facebook to use your facebook profile": "Login to facebook to use your facebook profile",
        "Login with Email": "Connectez-vous e-mail",
        "Login with Email (Full)": "Connectez-vous avec e-mail",
        "Login with Facebook": "Connectez-vous Facebook",
        "Login with Facebook (Full)": "Connectez-vous avec Facebook",
        "Maybe next time": "Peut-être la prochaine fois",
        "Medium": "Médium",
        "More Games": "Plus de jeux",
        "Name": "Nom",
        "Nice Hand": "Belle main",
        "Nicely played": "Bien joué",
        "No": "Non",
        "No lurch": "Pas de problème",
        "No Skunk": "Pas de skunk",
        "No thank you": "Non, merci",
        "Nooooooooooo": "Nonnnn!",
        "OK": "OK",
        "Online": "En ligne",
        "Oops": "Oups!",
        "Ouch": "Aie",
        "Phrases": "Phrases",
        "Play": "Jouer",
        "Play a Friend": "Défier un ami",
        "Play Again?": "Une autre partie?",
        "Private Room": "Chambre privée",
        "Profile": "Profile",
        "Random": "Aléatoire",
        "Rank": "Rang",
        "Rating": "Note",
        "Rematch?": "Rematch?",
        "Restore Data": "Réinitialiser le data",
        "Select an avatar": "Sélectionnez un avatar",
        "Sorry": "Désolé",
        "Statistics": "Statistiques",
        "Thank You": "Merci à toi",
        "Thanks": "Merci",
        "This will delete all of your data": "Cela supprimera toutes vos données",
        "Type a message": "Tapez un message",
        "Well played": "Bien joué",
        "Yes": "Oui",
        "You": "Vous",
        "You Win": "Vous gagnez!",
        "You're welcome": "De rien"
    }
};